import React, { useEffect, useMemo, useState } from "react";

const pageStyle = {
  minHeight: "100vh",
  background: "#0A0A0A",
  color: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif",
};

const cardStyle = {
  width: "100%",
  maxWidth: 460,
  background: "#141414",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: 16,
  padding: 32,
  textAlign: "center",
};

const allowedAuthOrigin = (() => {
  try {
    return new URL(process.env.REACT_APP_SUPABASE_URL || "").origin;
  } catch {
    return "";
  }
})();

const getRedirectUrl = () => {
  const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;
  const params = new URLSearchParams(hash);
  const rawUrl = params.get("to");
  if (!rawUrl || !allowedAuthOrigin) return null;

  try {
    const authUrl = new URL(rawUrl);
    if (authUrl.origin !== allowedAuthOrigin) return null;
    if (authUrl.pathname !== "/auth/v1/authorize") return null;
    if (authUrl.searchParams.get("provider") !== "google") return null;
    return authUrl.toString();
  } catch {
    return null;
  }
};

export default function MobileAuthRedirect() {
  const [status, setStatus] = useState("Opening Google...");
  const redirectUrl = useMemo(getRedirectUrl, []);

  useEffect(() => {
    if (!redirectUrl) {
      setStatus("We could not start Google sign-in. Return to Snows ProAm and try again.");
      return;
    }

    const timer = setTimeout(() => {
      window.location.replace(redirectUrl);
    }, 100);

    return () => clearTimeout(timer);
  }, [redirectUrl]);

  return (
    <main style={pageStyle}>
      <section style={cardStyle} aria-live="polite">
        <div style={{ height: 4, margin: "-32px -32px 28px", background: "linear-gradient(90deg, #0C69C8, #0A1D44)" }} />
        <h1 style={{ margin: "0 0 12px", fontSize: 26, lineHeight: 1.2 }}>Continue with Google</h1>
        <p style={{ margin: "0 auto", maxWidth: 360, color: "rgba(255,255,255,0.78)", lineHeight: 1.6 }}>
          {status}
        </p>
      </section>
    </main>
  );
}
